import React from 'react';
import PropTypes from 'prop-types';
// material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import FontIcon from './../../FontIcon/FontIcon';
import './CustomButton.scss';

const CustomButton = ({
    name, type, disabled, onClick, iconName, iconOnly, size, iconStyle, color, plain, outline
}) => {
    if(iconOnly){
        return(
            <IconButton
                type={ type }
                className={`Button icon-btn ${disabled ? 'disabled-btn' : ''} ${iconStyle ? 'btn-bg' : ''}`}
				disabled={ disabled }
                onClick={ onClick }
            >
                <FontIcon tooltip={name} iconName={iconName} size={size}  color={color} />
            </IconButton>
        );
    }
    return (
        <Button
            type={type}
            className={`Button normal-btn ${disabled ? 'disabled-btn' : ''} ${plain ? 'btn-trs' : ''} ${outline ? 'outline-btn' : ''}`}
            disabled={disabled}
            onClick={onClick}
        >
            {iconName !== '' && <FontIcon iconName={iconName} />}
            {name}
        </Button>
    );
}

CustomButton.propTypes = {
    outline: PropTypes.bool,
    name: PropTypes.string,
    type: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
	iconName: PropTypes.string,
	iconOnly: PropTypes.bool,
    size: PropTypes.string,
    iconStyle: PropTypes.bool,
    color: PropTypes.string,
    plain: PropTypes.bool
};

CustomButton.defaultProps = {
    name: '',
    type: null,
	disabled: false,
	onClick: () => {},
	iconName: '',
	iconOnly: false,
    size: 'default',
    iconStyle: false,
    color: '',
    plain: false,
    outline: false,

};

export default CustomButton;


// WEBPACK FOOTER //
// ./common/Forms/CustomButton/CustomButton.js